export default __webpack_public_path__ + "static/media/logo-icon-small.46dd8a6f.svg";